const config = JSON.parse(sessionStorage.getItem('config')) || {}

const labels = []

// Se configurado, utilizar
if (config.labelAdministracao) {
    labels['administracao'] = config.labelAdministracao
} else {
    labels['administracao'] = 'Administração'
}

export default labels
